<template>
	<div class="content-title-mobile">
		<b-avatar v-if="isAvatar" :size="31" :src="avatar"></b-avatar>
		<div
			class="btn-back"
			id="userMessage"
			v-if="isMessage"
			@click="backToMessageList"
		>
			<ChevronLeftIcon />
			{{ $t('back') }}
		</div>
		<div v-if="isDashboard" class="title-of-page text-center">
			{{ theGreeting }} {{ profileUser.display_name }}
			<IconSun />
		</div>
		<div v-else-if="isMessage" class="title-of-page text-center">
			{{ profileUser.display_name }}
		</div>
		<div v-else class="title-of-page text-center">
			{{ titlePage }}
		</div>
		<a
			id="userDashboard"
			v-if="!isDashboard"
			class="backToDashboard"
			href="javascript:;"
			@click="goBack"
		>
			<ViewDashboardIcon />
		</a>
	</div>
</template>
<script>
// Icons
import ViewDashboardIcon from 'vue-material-design-icons/ViewDashboard.vue';
import IconSun from '@/components/icons/IconSun';
import ChevronLeftIcon from 'vue-material-design-icons/ChevronLeft.vue';

const moment = require('moment');

export default {
	components: {
		ViewDashboardIcon,
		IconSun,
		ChevronLeftIcon
	},
	data() {
		return {
			theGreeting: '',
			avatar: '/images/avatar.png',
			profileUser: localStorage.getItem('user_profile')
				? JSON.parse(localStorage.getItem('user_profile'))
				: null
		};
	},
	props: {
		titlePage: {
			type: String,
			default: ''
		},
		isAvatar: {
			type: Boolean,
			default: false
		},
		isDashboard: {
			type: Boolean,
			default: false
		},
		isMessage: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		this.getTimeTheGreeting();
		this.getAvatarUser();
	},
	methods: {
		getTimeTheGreeting() {
			const now = moment().format('H');
			if (+now >= 5 && +now < 12) {
				this.theGreeting = this.$t('greeting.morning');
			} else if (+now >= 12 && +now < 17) {
				this.theGreeting = this.$t('greeting.afternoon');
			} else {
				this.theGreeting = this.$t('greeting.evening');
			}
		},
		backToMessageList() {
			this.$emit('isBack');
		},
		getAvatarUser() {
			if (localStorage && localStorage.getItem('user_profile')) {
				let avatar_url = JSON.parse(localStorage.getItem('user_profile'))
					.profile_image;
				if (avatar_url) {
					this.avatar = avatar_url;
				} else {
					this.avatar = '/images/avatar.png';
				}
			}
		},
		goBack() {
			if (
				this.$route.name != 'AdminManageListing' &&
				this.$route.name != 'AdminApproveListing' &&
				this.$route.name != 'AdminProfile'
			) {
				this.$router.push(this.$i18nRoute({ name: 'user-dashboard' }));
			} else {
				this.$router.push(this.$i18nRoute({ name: 'admin-dashboard' }));
			}
		}
	}
};
</script>
<style lang="scss">
@import 'greetingMobile.scss';
</style>
